import { sanitizeRichText } from "./sanitize-rich-text";

// Renders rich text (HTML) as sanitized markup. Centralizing the
// `dangerouslySetInnerHTML` + `sanitizeRichText` pairing here keeps callers from
// rendering unsanitized HTML by forgetting the sanitization step.
export function RichTextContent({
  value,
  className,
}: {
  value: string;
  className?: string;
}) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(value) }}
    />
  );
}
